import React from "react";
import { get } from "lodash";

export default function FullBleedImageSlice(slice) {
  const renderItems = (items) => {
    return items.map((el, i) => {
      const image = get(el, "image");

      if (!get(image, "url")) {
        return false;
      }

      return <img key={i} src={image.url} alt={get(image, "alt") || ""} />;
    });
  };

  const addMaxWidth = get(slice, "primary.add_max_width");

  return (
    <section
      className={`full-bleed-image-slice${
        addMaxWidth ? " add-max-width" : ""
      }`}
    >
      {renderItems(get(slice, "items", []))}
    </section>
  );
}
